import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-profile-settings-dialog-header",
  imports: [TranslateModule],
  templateUrl: "./profile-settings-dialog-header.component.html",
  styleUrl: "./profile-settings-dialog-header.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSettingsDialogHeaderComponent {}
